var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6614_17537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 5.32715C8.7678 5.32715 5.32715 8.7678 5.32715 13C5.32715 17.2321 8.7678 20.6728 13 20.6728C17.2321 20.6728 20.6728 17.2321 20.6728 13C20.6728 8.7678 17.2321 5.32715 13 5.32715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2892 11.3686C12.4346 11.0616 12.3053 10.7063 12.0146 10.5609C11.7077 10.4155 11.3523 10.5447 11.2069 10.8355C11.0777 11.1101 10.8515 11.2716 10.6092 11.2716C10.3669 11.2716 10.1408 11.1101 10.0116 10.8355C9.8662 10.5286 9.49467 10.4155 9.20391 10.5609C8.897 10.7063 8.78393 11.0778 8.92931 11.3686C9.26852 12.0632 9.91466 12.4831 10.6092 12.4831C11.3038 12.4831 11.95 12.047 12.2892 11.3686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8122 10.5448C16.5053 10.3994 16.1499 10.5286 16.0045 10.8194C15.8753 11.094 15.6492 11.2555 15.4069 11.2555C15.1646 11.2555 14.9384 11.094 14.8092 10.8194C14.6638 10.5125 14.2923 10.3994 14.0015 10.5448C13.6946 10.6902 13.5815 11.0617 13.7269 11.3524C14.0661 12.047 14.7123 12.467 15.4069 12.467C16.1014 12.467 16.7637 12.047 17.1029 11.3524C17.2322 11.0617 17.1191 10.7063 16.8122 10.5448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5684 14.3893C15.2776 14.2278 14.9061 14.3247 14.7446 14.6155C14.3892 15.2455 13.7269 15.6331 13 15.6331C12.2731 15.6331 11.6108 15.2455 11.2555 14.6155C11.0939 14.3247 10.7224 14.2278 10.4316 14.3893C10.1409 14.5509 10.044 14.9224 10.2055 15.2132C10.7709 16.2147 11.8531 16.8446 13 16.8446C14.1469 16.8446 15.2292 16.2147 15.8107 15.2132C15.9722 14.9224 15.8591 14.5509 15.5684 14.3893Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6614_17537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.3456,
    height: 15.3456,
    fill: "white",
    transform: "translate(5.32715 5.32715)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress);
export default __webpack_public_path__ + "static/media/stress.bce8fde31dab337bfbb58939c107411a.svg";
export { ForwardRef as ReactComponent };